import { Typography, styled } from '@mui/material'

export const ContrastTypography = styled(Typography)`
  font-family: ${(props) => props.theme.typography.fontFamily};
  color: ${(props) => props.theme.palette.primary.contrastText};
`
